import { FC } from "react";
import { Modal } from "@monolith-forensics/monolith-ui";
import EditEquipmentForm from "../Forms/EditEquipmentForm";
import { ForensicEquipment } from "@/types";

interface EditEquipmentModalProps {
  show: boolean;
  onClose: () => void;
  onSubmit: () => void;
  onCancel: () => void;
  defaultInfo: ForensicEquipment;
}

export const EditEquipmentModal: FC<EditEquipmentModalProps> = ({
  show,
  onClose,
  onSubmit,
  onCancel,
  defaultInfo,
}) => {
  const handleSubmit = () => {
    onSubmit?.(); // Refetch queries in software section
    handleClose();
  };

  const handleClose = () => {
    onClose?.();
  };
  const handleCancel = () => {
    onCancel?.();
  };

  return (
    <Modal open={show} onClose={onClose}>
      <EditEquipmentForm
        width={550}
        defaultFormData={defaultInfo}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
      />
    </Modal>
  );
};
